import * as t from "io-ts";
export const optional = (codec) => t.union([t.undefined, t.null, codec]);
export const realOptional = (codec) => t.union([t.undefined, codec]);
export const optionalOrEmpty = (codec) => new t.Type("optionalOrEmptyString", (u) => u === null || codec.is(u), (i, ctx) => {
    if (typeof i === "undefined" || i === null || i === "") {
        return t.success(null);
    }
    else {
        return codec.validate(i, ctx);
    }
}, (v) => (v === null ? null : codec.encode(v)));
export default optional;
//# sourceMappingURL=optional.js.map